let EditDict = {
  "order_state_type_b2b": [
    {
      "id": "1061",
      "label": "Pending Confirmation",
      "value": "0"
    },
    {
      "id": "1062",
      "label": "Pending Payment",
      "value": "1"
    },
    {
      "id": "1063",
      "label": "Pending Shipment",
      "value": "2"
    },
    {
      "id": "1064",
      "label": "Pending Delivery",
      "value": "3"
    },
    {
      "id": "1065",
      "label": "Completed",
      "value": "4"
    },
    {
      "id": "1066",
      "label": "Cancelled",
      "value": "5"
    },
    {
      "id": "1068",
      "label": "Pending Stock Preparation",
      "value": "7"
    },
    {
      "id": "1069",
      "label": "Pending Pickup",
      "value": "8"
    }
  ],
  "refund_appl_state_type_b2b": [
    {
      "id": "1081",
      "label": "Pending Review",
      "value": "0"
    },
    {
      "id": "1083",
      "label": "Rejected",
      "value": "2"
    },
    {
      "id": "1084",
      "label": "Completed",
      "value": "3"
    },
    {
      "id": "1085",
      "label": "Cancelled",
      "value": "4"
    }
  ]
};

module.exports = EditDict;